import { ref } from 'vue'

type SnackbarColor = 'primary' | 'secondary' | 'success' | 'warning' | 'error' | 'info' | string

export type SnackbarOptions = {
  message: string
  color?: SnackbarColor
  duration?: number
  onClick?: () => void
}

const snackbarVisible = ref(false)
const snackbarMessage = ref('')
const snackbarColor = ref<SnackbarColor>('primary')
const snackbarTimeout = ref(5000)
const snackbarClickHandler = ref<(() => void) | null>(null)

function mapColor(color?: string): SnackbarColor {
  if (!color) return 'primary'
  if (color === 'danger') return 'error'
  if (color === 'accent') return 'secondary'
  return color
}

export function useSnackbar() {
  const init = (options: SnackbarOptions) => {
    snackbarMessage.value = options.message
    snackbarColor.value = mapColor(options.color)
    snackbarTimeout.value = options.duration ?? 5000
    snackbarClickHandler.value = options.onClick ?? null
    snackbarVisible.value = true
  }

  const close = () => {
    snackbarVisible.value = false
    snackbarClickHandler.value = null
  }

  const handleClick = () => {
    snackbarClickHandler.value?.()
    close()
  }

  return {
    init,
    close,
    handleClick,
    snackbarVisible,
    snackbarMessage,
    snackbarColor,
    snackbarTimeout,
  }
}

/** @deprecated Use useSnackbar — kept for migration compatibility */
export const useToast = useSnackbar
